import { CODIFICATION_QUESTION_TYPE } from '../../constant/codification';
import { TH5PQuiz, TH5PQuizOption } from '../../models/courses/h5p';

export const createIdentifier = (prefix: string): string =>
  `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;

export const createDefaultOption = (): TH5PQuizOption => ({
  id: createIdentifier('answer'),
  label: '',
  isCorrect: false,
});

export const createDefaultQuiz = (): TH5PQuiz => ({
  id: createIdentifier('quiz'),
  time: 0,
  title: '',
  question: '',
  description: '',
  questionType: CODIFICATION_QUESTION_TYPE.SINGLE_CHOICE,
  minValidAnswers: 1,
  answers: [
    { id: createIdentifier('answer'), label: '', isCorrect: true },
    { id: createIdentifier('answer'), label: '', isCorrect: false },
  ],
  feedbackCorrect: '',
  feedbackIncorrect: '',
  allowRetry: true,
  pauseVideo: true,
});

export const sanitizeQuiz = (quiz: TH5PQuiz): TH5PQuiz => ({
  ...quiz,
  time: Math.max(0, Number.isFinite(quiz.time) ? quiz.time : 0),
  minValidAnswers: quiz.minValidAnswers ?? 1,
  answers: quiz.answers.map((answer) => ({
    ...answer,
    label: answer.label ?? '',
    isCorrect: !!answer.isCorrect,
  })),
});

export const extractPlaceholderIndices = (question: string): number[] => {
  if (!question) {
    return [];
  }
  const regex = /%(\d+)/g;
  const indices = new Set<number>();
  let match: RegExpExecArray | null;

  while ((match = regex.exec(question)) !== null) {
    const value = Number.parseInt(match[1], 10);
    if (!Number.isNaN(value)) {
      indices.add(value);
    }
  }

  return Array.from(indices).sort((a, b) => a - b);
};